import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import PageContext from '@contexts/pageContext'

import useCustomField from '@hooks/useCustomField'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

const confirmDelete = (deleteCustomField, deleteFn) => {
  const payload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Field Deleted',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure? It cannot be recovered.',
      title: 'Delete Custom Field?',
    })
    .then(({ value }) => {
      if (value){
        deleteCustomField(payload)
      }
    })
}

const CustomField = (props) => {
  const { customField } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: { deleteCustomField },
  } = pageContext

  const customFieldPayload = useCustomField(customField)
  const {
    callbacks: { createOrEditCustomField, deleteCustomField: deleteFn },
    customField: { field_type, label },
  } = customFieldPayload

  return (
    <DashboardModuleListItem title={label}>
      <DashboardModuleListItem.TertiaryText>
        {field_type}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditCustomField(customField)}
          type="edit"
        />

        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(deleteCustomField, deleteFn)}
          type="delete"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

CustomField.propTypes = {
  customField: PropTypes.object.isRequired,
}

export default CustomField
